import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState } from 'core/components';
import { PreviewLayout } from 'core/layouts';
import { AutoComplete } from "@progress/kendo-react-dropdowns";
import _ from 'lodash';

function PatientMissingDocsSearchTemplate({ patientMissingDocsSearchViewStore, t }) {
    const {
        loaderStore,
        localPatientStore,
        setPatientName
    } = patientMissingDocsSearchViewStore;

    return (
        <PreviewLayout className="container container--new-flow" store={patientMissingDocsSearchViewStore} emptyRenderer={<ApplicationEmptyState />} layoutFooterVisible={false} loading={loaderStore.loading}>
            <div className='container--missing-docs'>
                <label className='search-label'>{t('PATIENT_MISSING_DOCS.SEARCH.TITLE')}</label>
                <AutoComplete
                    className='search-input'
                    data={_.filter(localPatientStore.items, i => i.hideInDropdown !== true).map((i) => { return i.name })}
                    onClose={() => localPatientStore.onClose()}
                    onChange={(e) => { localPatientStore.onFilter(e.target.value); setPatientName(e.target.value); }}
                    placeholder={t('PATIENT_MISSING_DOCS.SEARCH.SEARCH_PATIENT_PLACEHOLDER')}
                />
            </div>
        </PreviewLayout >
    )
}

PatientMissingDocsSearchTemplate.propTypes = {
    patientMissingDocsSearchViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(PatientMissingDocsSearchTemplate);